module.exports = __webpack_public_path__ + "static/insta6-43901da5e6b4a213cf5a5fc82d1ef833.png";